// extracted by mini-css-extract-plugin
export default {"swiper":"BaseSwipeableDrawer_swiper__-shtm"};